import React from 'react';
import { mdiInformationOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { observer } from 'mobx-react';
//import './StaticTooltip.scss';
import './TooltipFromElement.scss'

export type TooltipDirections = 'top' | 'bottom' | 'left' | 'right';

interface IStaticTooltipfromElementProps {
  tooltipSide: TooltipDirections;
  children: any;
  id: string;
  extraClass?: string;
  icon?: string;
}

export const TooltipFromElement = observer((props: IStaticTooltipfromElementProps) => {
  const { tooltipSide, id, extraClass = '', icon = mdiInformationOutline, children } = props;

  return (
    <div className={`usa-tooltip static-tooltip-element ${extraClass}`}>
      <button id={`tooltip-button-${id}`} aria-labelledby={`tooltip-${id}`} className="usa-button--unstyled">
        <Icon path={icon} className="text-primary" size={1} />
      </button>
      <span id={`tooltip-${id}`} role="tooltip" className={`usa-tooltip__body usa-tooltip__body--${tooltipSide}`}>
        {children}
      </span>
    </div>
  );
});